$(document).ready(function() {
  $('.homepage-promo .slider').slick({
    speed: 300,
    autoplaySpeed: 5000,
    autoplay: true,
    arrows: true,
    prevArrow:
        '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">\n    <path fill="none" stroke="#FFF" stroke-width="3" d="M17.5 1.5l-15 15 15 15"/>\n  </svg>\n</button>',
    nextArrow:
        '<button class="slick-next slick-arrow" aria-label="Next" type="button">\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">\n    <path fill="none" stroke="#FFF" stroke-width="3" d="M1.5 31.5l15-15-15-15"/>\n  </svg>\n\t</button>',
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [{
      breakpoint: "1000",
      settings: "unslick"
    }]
  });
  
  var w = $(window).width();
  $(window).resize(function() {
    if (w >= 1000 && $(window).width() < 1000) {
      $('.homepage-promo .slider').slick('unslick');
      $('.homepage-promo .slider').slick({
        speed: 300,
        autoplaySpeed: 5000,
        autoplay: true,
        arrows: true,
        prevArrow:
            '<button class="slick-prev slick-arrow" aria-label="Previous" type="button">\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">\n    <path fill="none" stroke="#FFF" stroke-width="3" d="M17.5 1.5l-15 15 15 15"/>\n  </svg>\n</button>',
        nextArrow:
            '<button class="slick-next slick-arrow" aria-label="Next" type="button">\n  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19 33">\n    <path fill="none" stroke="#FFF" stroke-width="3" d="M1.5 31.5l15-15-15-15"/>\n  </svg>\n\t</button>',
        dots: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
          breakpoint: "1000",
          settings: "unslick"
        }]
      });
      
      $('.homepage-quick-shop .products').slick('unslick');
      $('.homepage-quick-shop .products').slick({
        mobileFirst: true,
        centerMode: true,
        variableWidth: true,
        responsive: [{
          breakpoint: "1000",
          settings: "unslick"
        }]
      });
    }
    w = $(window).width();
  });
  
  var currentSlide = 0;
  if ($('.homepage-promo .slide').length) {
    setInterval(function() {
      currentSlide++;
      var nextSlide;
      if (currentSlide == $('.homepage-promo .slide').length) {
        nextSlide = $('.homepage-promo .slide').eq(0);
        currentSlide = 0;
      }
      else nextSlide = $('.homepage-promo .slide').eq(currentSlide);
      $('.homepage-promo .current-text').css('opacity', '0');
      var t = setTimeout(function() {
        $('.homepage-promo .current-text').html(nextSlide.find('.quote').html());
        $('.homepage-promo .current-text').css('opacity', '1');
        clearTimeout(t);
      }, 300);
      nextSlide.addClass('active');
      nextSlide.siblings('.slide').removeClass('active');
    }, 5000);
  }
  
  $('.homepage-promo .slide').click(function() {
    if ($(window).width() >= 1000 && !$(this).hasClass('active')) {
      var slide = $(this);
      $('.homepage-promo .current-text').css('opacity', '0');
      var t = setTimeout(function() {
        $('.homepage-promo .current-text').html(slide.find('.quote').html());
        $('.homepage-promo .current-text').css('opacity', '1');
      },200);
      slide.addClass('active');
      slide.siblings('.slide').removeClass('active');
    }
  });
  
  $('.homepage-quick-shop .products').slick({
    mobileFirst: true,
    centerMode: true,
    variableWidth: true,
    responsive: [{
      breakpoint: "1000",
      settings: "unslick"
    }]
  });
  
//   if ($('.template-index').length) {
//     jQuery.ajax({
//       type: 'GET',
//       url: 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=7',
//       dataType: 'json',
//       success: function(data) { 
//         const res = data.response;
//         console.log(res)
//         let reviewStarsArray = '';
//         const average_score = res.bottomline.average_score;
//         for (let i = 0; i < 5; i++) {
//           reviewStarsArray += `<img src="//www.mymyro.com/cdn/shop/t/77/assets/star.svg?v=142386771965616102141707265074">`;
//         }
//         total = '(' + res.bottomline.total_review + (res.bottomline.total_review > 1 ? ' Reviews' : ' Review') + ')';
//         $('.reviews-stars').html(reviewStarsArray + '<a href="/pages/reviews">' + total + '</a>');
// //         $('.product-reviews-stars').html('<a href="/pages/reviews">' + reviewStarsArray + '<span>(' + res.bottomline.total_review + ' Reviews)</span></a>');
        
//         if ($('#reviews-slider').length) {
//           var reviews = res.reviews;
//           var reviewsHtml = '';
//           var limit = 180;
//           for (var i=0; i<reviews.length; i++) {
//             if (reviews[i].score > 3) {
//               var content = reviews[i].content;
//               if (content.length > limit) {
//                 content = content.slice( 0, limit);
//                 lastSpace = content.lastIndexOf(" ");
//                 if( lastSpace > 0) {
//                   content = content.substr(0, lastSpace);
//                 }
//                 content += '...';
//               }
//               var review = `
// 				<div class="review">
// 					<div class="content">
//                       ${content}
//                     </div>
// 					<div class="author">
//                       ${reviews[i].user.display_name}
//                     </div>
//                 </div>
//               `;
//               reviewsHtml += review;
//             }
//           }

//           $('#reviews-slider').html(reviewsHtml);
//           $('#reviews-slider').slick({
//             mobileFirst: true,
//             speed: 500,
//             infinite: false,
//             arrows: false,
//             dots: true,
//             adaptiveHeight: true,
//             responsive: [{
//               breakpoint: 1000,
//               settings: {
//                 adaptiveHeight: false,
//                 fade: true,
//               }
//             }]
//           });
//         }
//       },
//       error: function(){
//         console.log('Error');
//       }
//     });
//   }
          $('#reviews-slider').slick({
            mobileFirst: true,
            speed: 500,
            infinite: false,
            arrows: true,
            dots: true,
            adaptiveHeight: true,
            responsive: [{
              breakpoint: 1000,
              settings: {
                adaptiveHeight: false,
                fade: true,
              }
            }]
          });
  
  $('.product-reviews-stars').each(function() {
    var div = $(this);
    var url;
//     var deodorantProducts = ['833527709732', '833511915556', '833527414820', '833528528932', '833526923300', '5743593226394', '5743609086106', '5743595389082', '5743595389082'];
    var washProducts = ['7130386301082', '7130387513498', '7130388955290'];
    var link = $(this).attr('data-url');
    if ($(this).attr('data-id') == 7250571165850 || $(this).attr('data-id') == 7114026057882) {
      url = 'https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/yotpo_site_reviews/reviews.json?per_page=7';
    } else if ($(this).attr('data-id') == 7114026647706 || $(this).attr('data-id') == 7114024255642) {
      getReviews(washProducts, div);
      return;
    } else {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${div.attr('data-id')}/reviews.json?per_page=150`;
    }
    jQuery.ajax({
      type: 'GET',
      url: url,
      dataType: 'json',
      success: function(data) { 
        const res = data.response;
        console.log(res)
        if (res && res.reviews.length && res.bottomline.total_review > 3) {
          let reviewStarsArray = '';
          let num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
          const average_score = (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / num;
          for (let i = 0; i < 5; i++) {
            if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
            else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
          }
          div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
        } else {
          div.hide(0);
        }
      },
      error: function(){
        console.log('Error');
      }
    })
  });
  
  function getReviews(ids, div) {
    var counter = 0;
    var average = 0;
    var num = 0;
    var link = div.attr('data-url');
    for (var i=0; i<ids.length; i++) {
      url = `https://api.yotpo.com/v1/widget/CiVXTQWJKPQDTpBpVVH7Jio5qStY03R2duzV16P9/products/${ids[i]}/reviews.json?per_page=150`;
      jQuery.ajax({
        type: 'GET',
        url: url,
        dataType: 'json',
        success: function(data) { 
          const res = data.response;
          if (res.reviews.length) {
            var review_num = res.bottomline.star_distribution[4] + res.bottomline.star_distribution[5];
            num += review_num;
            average += (res.bottomline.star_distribution[4]*4 + res.bottomline.star_distribution[5]*5) / review_num;
            counter++;
            if (counter == ids.length) {
              var average_score = average / ids.length;
              let reviewStarsArray = '';
              for (let i = 0; i < 5; i++) {
                if ((average_score - i) >= 1) reviewStarsArray += `<div class="star"></div>`;
                else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<div class="star half"></div>`;
              }
              div.html('<a href="' + link + '">' + reviewStarsArray + '<span>(' + num + ')</span></a>');
              div.show(0);
            }
          } 
        },
        error: function(){
          console.log('Error');
        }
      });
    }
  }

  $('.homepage-quick-shop .product, .product-reviews-bundle').each(function() {
    if ($(this).find('.review-badges').length) {
      var totalScore = 0;
      var reviewNum = 0;
      var badgeNum = 0;
      $(this).find('.jdgm-widget').each(function() {
        var data = $(this).find('.jdgm-prev-badge');
        totalScore += +data.data('average-rating');
        reviewNum += +data.data('number-of-reviews');
        badgeNum++;
      });
      var average_score = totalScore / badgeNum;
      var reviewStarsArray = '';
      for (var i=0; i<5; i++) {
        if ((average_score - i) >= 1) reviewStarsArray += `<span class="jdgm-star jdgm--on"></span>`;
        else if ((average_score - i) < 1 && (average_score - i) > 0) reviewStarsArray += `<span class="jdgm-star jdgm--half"></span>`;
        else if ((average_score - i) < 0)  reviewStarsArray += `<span class="jdgm-star jdgm--off"></span>`;
      }
      var widget = `<div style="display: block !important;" class="jdgm-widget jdgm-preview-badge jdgm--done-setup" data-template="manual-installation" data-auto-install="false">
      <div class="jdgm-prev-badge">
      <span class="jdgm-prev-badge__stars"role="button">${reviewStarsArray}</span>
      <span class="jdgm-prev-badge__text">${reviewNum} reviews</span>
      </div></div>`;
      if (reviewNum) {
        $(this).find('.review-badges').after(widget);
      }
    }
  })
});